export function ViewModel(params, element) {
  element.classList.add("fc-drag-icon");
}
